import { MESSAGES } from "../actions";
import { messageState } from "../../utils/messajes";

const defaultState = {
  deleteStatus: messageState.IDLE,
  fileStatus: messageState.IDLE,
  userStatus: messageState.IDLE,
  uploadStatus: messageState.IDLE,
  proposalStatus: messageState.IDLE,
  downLoadStatus: messageState.IDLE
};

const ACTION_HANDLERS = {
  [MESSAGES.PROPOSAL_STATUS]: (state, { payload }) => ({ ...state, proposalStatus: payload }),
  [MESSAGES.DELETE_STATUS]: (state, { payload }) => ({ ...state, deleteStatus: payload }),
  [MESSAGES.UPLOAD_STATUS]: (state, { payload }) => ({ ...state, uploadStatus: payload }),
  [MESSAGES.DOWNLOAD_STATUS]: (state, { payload }) => ({ ...state, downLoadStatus: payload }),
  [MESSAGES.FILE_STATUS]: (state, { payload }) => ({ ...state, fileStatus: payload }),
  [MESSAGES.USER_STATUS]: (state, { payload }) => ({ ...state, userStatus: payload })
};

export default (state = defaultState, action) => {
  const handler = ACTION_HANDLERS[action.type];
  const newState = handler ? handler(state, action) : state;
  return newState;
};
